import ClockCircleOutlined from "@ant-design/icons/ClockCircleOutlined";
import { Button, Modal, Result } from "antd";

import { useIdleState } from "@hooks/useIdleState";

export const IdleModal = () => {
  const { inactivityModalOpen, remainingTime, onKeepSession } = useIdleState();

  const formattedRemainingTime = `${remainingTime} ${
    remainingTime === 1 ? "segundo" : "segundos"
  }`;

  return (
    <Modal
      width={600}
      open={inactivityModalOpen}
      onCancel={onKeepSession}
      footer={null}
    >
      <Result
        status="info"
        icon={<ClockCircleOutlined />}
        title="Você ainda está aqui?"
        subTitle={`Você será desconectado do sistema em ${formattedRemainingTime}.`}
        extra={[
          <Button key="keep-session" type="primary" onClick={onKeepSession}>
            Estou aqui
          </Button>,
        ]}
      />
    </Modal>
  );
};
